import { TS_AddonCatering }     from 'Models/TravelSeller/Models/TS_AddonCatering';
import { BookingItemInterface } from './BookingItemInterface';

export class AddonCatering extends TS_AddonCatering implements BookingItemInterface {
}